"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useButtonVariantClass = void 0;
var theme_1 = require("../../../theme");
var common_utils_1 = require("../../../tools/common-utils");
var variants = {
    primary: {
        container: 'primary',
        iconColor: 'squid-text-alias-color-text-on-primary',
        border: 'squid-border-transparent',
    },
    outlined: {
        container: 'base',
        iconColor: 'squid-text-alias-color-text-on-outline',
        border: {
            default: 'squid-border-alias-color-border-base',
            hover: 'hover:squid-border-alias-color-border-base',
            active: 'active:squid-border-alias-color-border-base',
        },
    },
    plain: {
        container: 'base',
        iconColor: 'squid-icon-alias-color-icon-base',
        border: 'squid-border-transparent',
    },
};
var disabledVariants = {
    primary: {
        container: 'disabled',
        iconColor: 'squid-text-alias-color-text-disabled',
        border: 'squid-border-transparent',
    },
    outlined: {
        container: 'transparent',
        iconColor: 'squid-text-alias-color-text-disabled',
        border: {
            default: 'squid-border-alias-color-border-base',
            hover: 'hover:squid-border-alias-color-border-base',
            active: 'active:squid-border-alias-color-border-base',
        },
    },
    plain: {
        container: 'transparent',
        iconColor: 'squid-text-alias-color-text-disabled',
        border: 'squid-border-transparent',
    },
};
var useButtonVariantClass = function (_a) {
    var variant = _a.variant, disabled = _a.disabled, branding = _a.branding;
    var bgColors = (0, theme_1.useBackgroundColors)(branding);
    var bgStateColors = (0, theme_1.useBackgroundStateColors)(branding);
    var ring = (0, theme_1.useRingStyles)(branding);
    var realVariants = disabled ? disabledVariants : variants;
    var classes = realVariants[variant];
    var container;
    if (!disabled) {
        switch (variant) {
            case 'outlined':
            case 'plain':
                container = "".concat(bgColors.transparent, " ").concat(bgStateColors.base);
                break;
            default:
                container = "".concat(bgColors.primary, " ").concat(bgStateColors.primary);
                break;
        }
    }
    else {
        container =
            classes.container === 'base'
                ? "".concat(bgColors.transparent, " ").concat(bgStateColors.base)
                : "".concat(bgColors.transparent, " hover:squid-bg-transparent active:squid-bg-transparent");
    }
    return (0, common_utils_1.toArray)(__assign(__assign(__assign({}, classes), { container: container }), ring));
};
exports.useButtonVariantClass = useButtonVariantClass;
